import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BaseRepository } from 'app/shared/models/interfaces/base-repository';
import { ThemePalette } from '@angular/material/core';


@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss']
})
export class AutocompleteComponent<T extends BaseRepository> implements OnInit {
  @Input() list: T[];
  @Input() control: UntypedFormControl;
  @Input() label: string;
  @Input() errorMsg: string;
  @Input() number: number;
  @Input() canString: boolean;
  @Input() disabled: boolean;
  @Input() isFilter: boolean;
  @Input() hasTooltip: boolean;
  @Input() tooltipText: boolean;
  @Input() valueWanted: string;
  @Input() set setSites(value: T[]) {
    this.list = value;
    this.setfilters();
 }

 @Output() selectedOptionForFilter = new EventEmitter<any>();

  filteredList: Observable<T[]>;

  constructor(
    private faIconService: FaiconService
  ) { }

  ngOnInit() {
    this.setfilters();
    // if (this.list.length === 1) {
    //   this.control.setValue(this.list[0]);
    // }

    if (this.disabled) {
      this.control.disable();
    }
  }

  displayFn(object: T): string | undefined {
    return object ? (object.display || object.toString()) : null;
  }

  private setfilters(): void {
    let validators = [];

    if (this.canString) {
      validators = [];
    }
     else {
      validators = [this.forbiddenTypeValidator('string')];
    }

    if (this.control.validator) {
      validators.push(this.control.validator);
    }

    this.control.setValidators(validators);


    this.filteredList = this.control.valueChanges
      .pipe(
        startWith(''),
        map((value: string | T) => typeof value === 'string' ? value : value?.display),
        map((value: string) => value ? this.filter(value) : this.list.slice())
      );
  }

  private filter(value: string): T[] {
    const filterValue = value.toLowerCase();
    return this.list.filter(item => item.doesInclude(filterValue));
  }

  private forbiddenTypeValidator(forbiddenType: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const forbidden = control.value !== '' && typeof control.value === forbiddenType;
      return forbidden ? { forbiddenType: { value: control.value } } : null;
    };
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }
}
